import { defineStore } from 'pinia';
import strapiService from '@/services/strapi';
import { useAuthStore } from '@/stores/auth';

export const useTalleresStore = defineStore('talleres', {
    state: () => ({
        talleres: [],
        tallerActual: null,
        alumnoActual: null,
        idCuento: 0,
        estadisticas: {},
        estadisticasAudio: {},
        estadisticasNuevas: {},
        cuento: {},
        schema: null,
        isPreview: false
    }),
    getters: {
        stats: (state) => {
            if (!state.estadisticas) return {};

            return {
                profesion: calculateCategoryStats(state.estadisticas.profesionStats, 'profesion'),
                genero: calculateCategoryStats(state.estadisticas.generoStats, 'genero'),
                edad: calculateCategoryStats(state.estadisticas.edadStats, 'generacion'),
                signo: calculateCategoryStats(state.estadisticas.signoStats, 'signo'),
                ubicacion: calculateCategoryStats(state.estadisticas.ubicacionStats, 'pais'),
                estudios: calculateCategoryStats(state.estadisticas.estudiosStats, 'estudios'),
                hijos: calculateCategoryStats(state.estadisticas.hijosStats, 'hijos'),
                estadoCivil: calculateCategoryStats(state.estadisticas.estadoCivilStats, 'estado_civil'),
                general: {
                    totalVotos: state.estadisticas.totalVotos,
                    sumaEstrellas: state.estadisticas.sumaEstrellas,
                    promedioEstrellas: state.estadisticas.promedioEstrellas,
                    totalBalas: state.estadisticas.totalBalas,
                    totalLecturas: state.estadisticas.totalLecturas,
                },
                cuento: state.cuento
            }
        },

        audioStats: (state) => {
            return state.estadisticasAudio;
        },
        camposPerfilDefault: () => [
            'urlImagen',
            'fechaNacimiento',
            'paisNacimiento',
            'pais',
            'estudios',
            'profesion',
            'estadoCivil',
            'hijos'
        ],
        camposPerfil: (state) => {
            console.log("state.tallerActual", state.tallerActual)
            return state.tallerActual?.datosPerfil || state.camposPerfilDefault;
        },
        perfilCompleto: (state) => () => {
            // Obtener el usuario actual, utilizando authStore
            const authStore = useAuthStore();
            const userData = authStore.usuario;

            const camposRequeridos = state.tallerActual?.datosPerfil || state.camposPerfilDefault;

            console.log("🔍 Verificando perfil completo:");
            console.log("📋 camposRequeridos", camposRequeridos);
            console.log("👤 userData", userData);
            console.log("🎯 tallerActual", state.tallerActual);
            
            // Asegurar que camposRequeridos sea un array
            const camposArray = Array.isArray(camposRequeridos) ? camposRequeridos : state.camposPerfilDefault;
            console.log("📋 camposArray (asegurado como array):", camposArray);
            
            // Verificar si todos los campos requeridos están completos
            const perfilCompleto = camposArray.every(campo =>
                userData[campo] || (userData.extra && userData.extra[campo])
            );

            // Mostrar los campos que no están completos para debugging
            const camposNoCompletos = camposArray.filter(campo => 
                !userData[campo] && !(userData.extra && userData.extra[campo])
            );
            console.log("❌ Campos no completos:", camposNoCompletos);
            console.log("✅ Perfil completo:", perfilCompleto);
            
            return perfilCompleto;
        }
    },
    actions: {
        actualizarAlumnoActual(alumno) {
            this.alumnoActual = alumno;
        },
        establecerPreview() {
            this.isPreview = true;
        },
        async cargarTalleres() {
            try {
                this.talleres = await strapiService.getTalleres();
            } catch (error) {
                console.error('Error al cargar talleres:', error);
            }
        },
        async setTallerActual(slug) {
            try {
                console.log('🎯 setTallerActual iniciado para slug:', slug);
                const taller = await strapiService.getTallerBySlug(slug);
                console.log('📚 Taller obtenido:', taller);
                this.tallerActual = taller;

                // Verificar autenticación y cargar alumno si es necesario
                const authStore = useAuthStore();
                console.log('🔐 Verificando autenticación...');
                await authStore.estaAutenticado();
                console.log('✅ Autenticación verificada');
                console.log('👤 Cargando alumno actual...');
                await this.cargarAlumnoActual();
                console.log('✅ Alumno actual cargado');
            } catch (error) {
                console.error('❌ Error al cargar el taller:', error);
                this.tallerActual = null;
            }
        },
        setTaller(taller) {
            this.tallerActual = taller;
        },
        actualizarTituloPagina(nombrePagina) {
            const nombreTaller = this.tallerActual?.nombre || '';
            // document.title = `${nombrePagina} - ${nombreTaller} - Escuela Orsai`;
        },
        setSchema(schema) {
            this.schema = schema;
        },
        parseDescription(template) {
            // Obtener stats de los gettersx
            const data = this.stats;
            // Reemplazar state.stats por data
            template = template.replace(/state\.stats\./g, "data.")

            return template.replace(/\{\{\s*(.*?)\s*\}\}/g, (_, expression) => {
                try {
                    // Crear una función que ejecutará la expresión con el contexto de data
                    const evalFunction = new Function(
                        "data",
                        `
        try {
          return ${expression};
        } catch (e) {
          return '';
        }
      `,
                    )

                    // Ejecutar la función con los datos
                    const result = evalFunction(data)

                    // Manejar undefined/null
                    return result !== undefined && result !== null ? result : ""
                } catch (error) {
                    console.error("Error evaluando expresión:", expression, error)
                    return ""
                }
            });
        },
        async fetchEstadisticas(idCuentoForzado = null, config = { audio: true, general: true }) {
            const idCuento = idCuentoForzado || this.idCuento;
            const responseCuento = await strapiService.getCuentos({
                "filters[documentId]": idCuento
            });

            this.cuento = await responseCuento.data[0]

            // Verificar que el cuento existe antes de continuar
            if (!this.cuento) {
                console.error('No se encontró el cuento con ID:', idCuento);
                return;
            }

            // Siempre cargar las nuevas estadisticas
            const responseNuevas = await strapiService.getCuentosStatsNuevas(this.cuento.id);
            this.estadisticasNuevas = responseNuevas
            console.log("Estadisticas nuevas", this.estadisticasNuevas)

            if (config.general) {
                const response = await strapiService.getCuentosStats(this.cuento.id);
                console.log("Response", response)
                this.estadisticas = response
                console.log("Estadisticas", this.estadisticas)
            }
            if (config.audio) {
                const response = await strapiService.getCuentosStatsAudio(this.cuento.id);
                this.estadisticasAudio = response
            }
        },
        setIdCuento(id) {
            this.idCuento = id;
        },
        async cargarAlumnoActual() {
            const authStore = useAuthStore();
            const idUsuario = authStore.usuario?.id;

            if (!idUsuario) {
                console.error('No hay usuario autenticado');
                return;
            }

            const email = authStore.usuario?.email;

            try {
                const response = await strapiService.get(`/api/alumnos?filters[email]=${email}&populate=*`);
                if (response.data && response.data.length > 0) {
                    this.alumnoActual = response.data[0];
                } else {
                    console.error('No se encontró el alumno para el usuario actual');
                }
            } catch (error) {
                console.error('Error al cargar el alumno:', error);
            }
        }
    },
});

// Función para calcular estadísticas de cada categoría
function calculateCategoryStats(stats, categoryField) {
    if (!stats || !stats.length) return null;

    // Filtrar entradas sin votos y ordenar por cantidad de votos
    const filteredStats = stats
        .filter(stat => stat.cantidadVotos > 0)
        .sort((a, b) => b.cantidadVotos - a.cantidadVotos);

    if (!filteredStats.length) return null;

    const totalVotos = filteredStats.reduce((sum, stat) => sum + stat.cantidadVotos, 0);
    const totalLecturas = filteredStats.reduce((sum, stat) => sum + stat.cantidadLecturas, 0);

    const masVotado = filteredStats[0];
    const masLeido = filteredStats.reduce((max, stat) =>
        stat.cantidadLecturas > max.cantidadLecturas ? stat : max
    );
    const mejorPromedio = filteredStats.reduce((max, stat) =>
        (stat.promedioVotos || 0) > (max.promedioVotos || 0) ? stat : max
    );

    // Formatear el valor de la categoría según el campo
    const formatValue = (value) => {
        if (value === null) return 'No contesta';

        switch (categoryField) {
            case 'profesion':
                return formatProfesion(value);
            case 'estado_civil':
                return formatEstadoCivil(value);
            case 'generacion':
                return formatGeneracion(value);
            case 'genero':
                return formatGenero(value);
            default:
                return value.charAt(0).toUpperCase() + value.slice(1);
        }
    };

    return {
        totalVotos,
        totalLecturas,
        masLeido,
        masVotado,
        mejorPromedio,
        porcentajeVotosMasVotado: ((masVotado.cantidadVotos / totalVotos) * 100).toFixed(0),
        porcentajeLecturasMasLeido: ((masLeido.cantidadLecturas / totalLecturas) * 100).toFixed(0),
        categoriasMasVotada: formatValue(masVotado[categoryField]),
        categoriasMasLeida: formatValue(masLeido[categoryField]),
        categoriaMejorPromedio: formatValue(mejorPromedio[categoryField]),
        totalCategorias: filteredStats.length,
        participacionPromedio: (totalVotos / filteredStats.length).toFixed(0),
        lecturasPromedio: (totalLecturas / filteredStats.length).toFixed(0),
        datos: filteredStats
    };
}

// Funciones de formateo
function formatProfesion(profesion) {
    if (profesion === 'no contesta') return 'No contesta';
    return profesion.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

function formatEstadoCivil(estado) {
    const formatos = {
        'casado': 'Casado/a',
        'soltero': 'Soltero/a',
        'divorciado': 'Divorciado/a',
        'viudo': 'Viudo/a',
        'separado': 'Separado/a',
        'concubino': 'En concubinato'
    };
    return formatos[estado] || estado;
}

function formatGeneracion(generacion) {
    const formatos = {
        'boomer': 'Baby Boomer',
        'genX': 'Generación X',
        'genZ': 'Generación Z',
        'millennial': 'Millennial'
    };
    return formatos[generacion] || generacion;
}

function formatGenero(gender) {
    const genderMap = {
        'female': 'Mujeres',
        'male': 'Hombres',
        'unisex': 'Unisex',
        'unknown': 'Desconocido'
    };
    return genderMap[gender] || 'Otro';
};